<div>
    <app-customers-edit [customerInfoByGroupId]="customerInfoByGroupId"
                        [showBreadCrumb]="false"
                        [showCustomerDetailsTab]="showCustomerDetailsTab"
                        [showAircraftTab]="false"
                        [showPricingTab]="showPricingTab"
                        [showAnalyticsTab]="false"
                        [showHistoryTab]="false"
                        [showClose]="false"
                        [alternateTitle]="title"></app-customers-edit>
    <div class="row mt-5">
        <div class="col-12">
            <div class="pull-right">
                <button (click)="close()" mat-stroked-button>
                    Close
                </button>
            </div>
        </div>
    </div>
</div>
